import React, { useState, useEffect } from "react";

import UserDropdown from "components/Dropdowns/UserDropdown.js";
import WelcomeUser from "../../WelCome";

export default function Navbar() {

  const [userlogin, setUserlogin] = useState([]);
  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/userstatuscheck/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setUserlogin(resp))
      .catch((error) => {
        console.error(error);
      });
  }, []); 

  return (
    <>
      <nav className="absolute top-0 left-0 w-full z-10 bg-transparent md:flex-row md:flex-nowrap md:justify-start flex items-center p-4">
        <div className="w-full mx-autp items-center flex justify-between md:flex-nowrap flex-wrap md:px-10 px-4">
          <WelcomeUser userlogin={userlogin}/>
          <form className="md:flex hidden flex-row flex-wrap items-center lg:ml-auto mr-3">
          </form>
          <ul className="flex-col md:flex-row list-none items-center hidden md:flex">
            <UserDropdown />
          </ul>
        </div>
      </nav>
    </>
  );
}
